const data = [
  { to: "products", name: "Products" },
  { to: "productsDetail", name: "Products Detail" },
  { to: "orders", name: "Orders" },
  { to: "customers", name: "Customers" },
  { to: "cart", name: "Cart" },
  { to: "checkout", name: "Checkout" },
  { to: "shops", name: "Shops" },
  { to: "create_offer", name: "Create Offer" },
  { to: "addproduct", name: "Addproduct" },
];

export default data;
